// CardHeader.jsx
import React, { useContext } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { useSelector } from "react-redux";
import { BI_WS0000Context } from "../context";

const CardHeader = ({ titulo, Texto_Info, ESG_Info, togglePopup, slugId, textoIA, Codigo_Transacao_Link, Titulo_Transacao_Link }) => {

  const { paramsOnFilter } = useContext(BI_WS0000Context) || {}
  const isIframePage = useSelector((state) => state.Layout.isIframePage)

  const buildLinkWithFilters = () => {
    if (!Codigo_Transacao_Link) return ''
    const filterParams = paramsOnFilter?.[0] || {}
    const queryParts = []

    Object.entries(filterParams).forEach(([key, entry]) => {
      let value
      if (Array.isArray(entry)) {
        if (entry[0]?.values) {
          value = entry[0].values.map(o => o.value).join(',')
        } else {
          value = entry.map(o => o.value).join(',')
        }
      } else if (entry && typeof entry === 'object' && 'value' in entry) {
        value = entry.value
      } else {
        value = entry
      }
      if (value != null && value !== '') {
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      }
    })

    const separator = Codigo_Transacao_Link.includes('?') ? '&' : '?'
    let url = queryParts.length > 0
      ? `${Codigo_Transacao_Link}${separator}${queryParts.join('&')}`
      : Codigo_Transacao_Link

    if (isIframePage) {
      const iframeParams = new URLSearchParams(window.location.search).toString()
      if (iframeParams) {
        url += `${url.includes('?') ? '&' : '?'}${iframeParams}`
      }
    }

    return url
  }

  const handleLinkClick = () => {
    if (Codigo_Transacao_Link) {
      window.open(buildLinkWithFilters(), '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className=" d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center ">
        <h6 className="mb-0 font-w-600 font-size-16 text-color-azul1">{titulo}</h6>        
        <div id={`infoIcon-${slugId}`}>
            <i className="ps-2 fas fa-info-circle fa-info-circle-dash font-size-15" />
          </div>
        {Codigo_Transacao_Link && (
          <>
            <div 
              id={`linkIcon-${slugId}`}
              onClick={handleLinkClick}
              style={{ cursor: 'pointer' }}
              className="ps-2"
            >
              <i className="fas fa-external-link-alt font-size-15 text-color-cinza4" />
            </div>
            <UncontrolledTooltip
              target={`linkIcon-${slugId}`}
              className="custom-tooltip"
            >
              {Titulo_Transacao_Link || ""}
            </UncontrolledTooltip>
          </>
        )}
      </div>


      {/* Ícones de Ação */}
      <div className="d-flex align-items-center ms-auto flex-shrink-0">

        {slugId && (              
          <UncontrolledTooltip target={`infoIcon-${slugId}`} className="custom-tooltip">
            {/* Cabeçalho do tooltip */}
            <div className="tooltip-title">
              <i className="bx bxs-cube-alt icon-tooltip-title" style={{ fontSize: "1.2rem" }}></i>
              <span>  {slugId} </span>
            </div>
            
            {/* Texto do tooltip */}
            <div className="tooltip-text">
              {Texto_Info}
            </div>
          </UncontrolledTooltip>

    
        )}
        
        {ESG_Info && (
          <span
            id={`EsgIcon-${slugId}`}
            className="icon-circle icon-circle-green ms-2"
          >
            <i className="fa-thin fa-leaf folha" />
            <UncontrolledTooltip
              target={`EsgIcon-${slugId}`}
              className="custom-tooltip"
            >
              {ESG_Info}
            </UncontrolledTooltip>
          </span>
        )}

        {textoIA && (
          <span
            id={`AiIcon-${slugId}`}
            className="icon-circle icon-circle-blue ms-2"
            onClick={togglePopup}
          >
            <i className="fas fa-microchip micro" />
            <UncontrolledTooltip
              target={`AiIcon-${slugId}`}
              className="custom-tooltip"
            >
              SuperInsights
            </UncontrolledTooltip>
          </span>
        )}
      </div>
    </div>
  );
};

export default CardHeader;
